// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__fPXBa","title":"Navbar_title__6kc2N"};